import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { AiSearchApi, AiSearchApiImpl } from './apis';
import { DataCoverageApi, DataCoverageApiImpl } from './apis/dataCoverage';

export const aiSearchContainer = new ContainerModule((bind) => {
    bind<AiSearchApi>(AiSearchApi).to(AiSearchApiImpl);
    bind<DataCoverageApi>(DataCoverageApi).to(DataCoverageApiImpl);
});

export { AiSearchApi } from './apis';
export { DataCoverageApi } from './apis/dataCoverage';
